/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

export class BoxHelper {

  static box = {
    class: 'Shape3D.Box',
    data:
    {
      sizeX: 329.69574781093803039,
      sizeY: 40.30425218906195539,
      sizeZ: 80,
      pose:
      {
        Type: 'RIGID',
        Matrix: [
          [0.83586260424495133, 0.54893870953399490, 0, 120.38710784912109375],
          [-0.54893870953399490, 0.83586260424495133, 0, 303.26358032226562500],
          [0, 0, 1, 40],
          [0, 0, 0, 1],
        ],
      },
    },
  };

  static shape2Plank = (() => {

    const realCornerX = 630 / 2;
    const realCornerY = 590 / 2;

    const offsetX = 50;
    const offsetY = 50;
    const scaleX = 50 / realCornerX;
    const scaleY = 50 / realCornerY;

    let lastPlank = { x: 0, y: 0, angle: 0 };

    return (obj) => {
      if (!!obj.class && obj.class == 'Shape3D.Box') {
        const vx = obj.data.pose.Matrix[0][0];
        const vy = obj.data.pose.Matrix[0][1];
        const ez = obj.data.pose.Matrix[2][2];

        const px = obj.data.pose.Matrix[1][3];
        const py = obj.data.pose.Matrix[0][3];

        lastPlank = { x: px * scaleX + offsetX, y: py * scaleY + offsetY, angle: Math.atan2(-ez * vy, vx) };
        return lastPlank;
      }
      return lastPlank;
    };
  })();
}
